import { SkeletonCustomRoutineList } from 'components/setting-generator-revamp/tabs-body-steps-revamp/skeleton-routine';
import AddHabitButton from 'components/setting-generator-revamp/tabs-revamp/AddHabitButton';
import { ROUTINE } from 'constants/general';
import { t } from 'services/i18n.service';
import { useAppSelectorShallow } from 'store/hooks';
import { customRoutinesSelector } from 'store/reducer/setting/selectors';
import CustomRoutineListItem from './CustomRoutineListItem';

const CustomRoutines = () => {
  const { customRoutines, isSettingLoading } = useAppSelectorShallow(
    customRoutinesSelector
  );

  if (isSettingLoading) {
    return <SkeletonCustomRoutineList />;
  }

  return (
    <ul
      className='w-full min-h-full h-fit max-h-full flex flex-col ~gap-6/10 items-center ~py-3/4'
      data-testid='custom-routines-wrapper'>
      {customRoutines?.length
        ? customRoutines.map((routine, idx) => (
            <CustomRoutineListItem
              key={routine.id}
              routine={routine}
              index={idx}
            />
          ))
        : null}
      <AddHabitButton
        routine={!customRoutines?.length ? ROUTINE.CUSTOM_ROUTINES : undefined}
        title={
          !customRoutines?.length
            ? t('add_your_first_custom_routine')
            : t('settings_page.add_routine')
        }
        additionalBtnStyles={
          customRoutines?.length ? 'absolute ~top-3.5/4 ~left-2.5/5' : ''
        }
        size={customRoutines?.length ? 'xs' : 'sm'}
      />
    </ul>
  );
};

export default CustomRoutines;
